import moment, { Moment } from 'moment'

// C&C-only: the per-item "Lead time in days" (CashAssist article → Click & Collect tab)
// gates the app the same way the company-level cutoff (QRM-632) does — day granularity,
// device-local clock (all C&C customers are CH/DE = the server's Europe/Zurich).

const isClickCollectBuild = () => process.env.REACT_APP_IS_CLIC === '1'

export const getItemLeadDays = (
  leadDaysCount?: number | string | null
): number => {
  if (leadDaysCount == null || leadDaysCount === '') return 0
  const parsed = Number(leadDaysCount)
  return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : 0
}

export const isItemLeadDaysExceeded = ({
  leadDays,
  pickUpTime,
  now = moment(),
}: {
  leadDays: number
  pickUpTime?: string | null
  now?: Moment
}): boolean => {
  if (!isClickCollectBuild() || leadDays < 1) return false
  const pickup = pickUpTime ? moment(pickUpTime) : null
  if (!pickup || !pickup.isValid()) return false
  const earliestAllowedDay = moment(now).startOf('day').add(leadDays, 'days')
  return moment(pickup).startOf('day').isBefore(earliestAllowedDay)
}

export const formatLeadDaysNotice = (
  t: (key: string, options?: Record<string, unknown>) => string,
  leadDays: number
): string =>
  leadDays === 1
    ? t('clickCollect.leadDaysNoticeSingular')
    : t('clickCollect.leadDaysNotice', { days: leadDays })

export const formatLeadDaysModalWarning = (
  t: (key: string, options?: Record<string, unknown>) => string,
  leadDays: number
): string =>
  leadDays === 1
    ? t('clickCollect.leadDaysModalWarningSingular')
    : t('clickCollect.leadDaysModalWarning', { days: leadDays })
